
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/quick-meet/join/[slug]",
      function () {
        return require("private-next-pages/admin/quick-meet/join/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/quick-meet/join/[slug]"])
      });
    }
  